import { fmtDate, type SupplierChangeLogRow } from '@dcc-erp/shared';

import { useSupplierChangeLog } from '../../lib/queries/suppliers';
import { AppModal } from '../AppModal';

// Append-only supplier master change history (read-only). Reuses the AppModal
// shell + an ApprovalTimeline-style row card per change.
export function ChangeHistoryDrawer({
  companyId,
  supplierId,
  onClose,
}: {
  companyId: string | undefined;
  supplierId: string;
  onClose: () => void;
}) {
  const { data = [], isLoading } = useSupplierChangeLog(companyId, supplierId);
  return (
    <AppModal
      title="ประวัติการแก้ไข"
      subtitle="บันทึกการเปลี่ยนแปลงข้อมูลผู้ขาย (อ่านอย่างเดียว)"
      onClose={onClose}
      footer={
        <button type="button" className="btn primary" onClick={onClose}>
          ปิด
        </button>
      }
    >
      {isLoading ? (
        <div className="meta">กำลังโหลด…</div>
      ) : data.length === 0 ? (
        <div className="meta">— ยังไม่มีการแก้ไข —</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {data.map((r: SupplierChangeLogRow) => (
            <div
              key={r.id}
              style={{
                padding: '10px 12px',
                background: '#fafafa',
                border: '1px solid var(--border)',
                borderRadius: 6,
              }}
            >
              <div style={{ fontWeight: 600 }}>
                {r.field}
                {r.vendorId ? (
                  <span className="badge neutral" style={{ marginLeft: 6 }}>
                    สาขา
                  </span>
                ) : null}
              </div>
              <div className="meta">
                <s>{r.oldValue ?? '—'}</s> → <b>{r.newValue ?? '—'}</b>
              </div>
              <div className="meta">
                {r.actor ?? 'ระบบ'} · {fmtDate(r.at)}
              </div>
            </div>
          ))}
        </div>
      )}
    </AppModal>
  );
}
